import { MenuItem } from '../../types/menu';

export const hasChildWithUrl = ({ submenu }: MenuItem, url: string): boolean => {
  return !!submenu?.find((subitem) => subitem.url === url || hasChildWithUrl(subitem, url));
};
